import usePostData from "@/hooks/usePostData";
import { ProjectType } from "@/types";
export function useDatabase() {
  const { postData } = usePostData<any>();

  const updateProjectInDB = async (
    data,
    id?: number | null,
    responseType?: string | null
  ): Promise<ProjectType> => {
    let url = "";

    if (id) {
      url = `${import.meta.env.VITE_IP_API}/api/project/edit/${id}`;
      if (responseType === "payload") {
        url += "?responseType=payload";
      }
    } else {
      url = `${import.meta.env.VITE_IP_API}/api/project/save`;
    }

    const project = await postData({
      url,
      data,
      skipCacheRefresh: !!id,
    });
    return project;
  };

  const updateProgramInDB = async (
    data,
    id?: number | null
  ): Promise<ProjectType> => {
    let url = "";
    if (id) {
      url = `${import.meta.env.VITE_IP_API}/api/program/edit/${id}`;
    } else {
      url = `${import.meta.env.VITE_IP_API}/api/program/save`;
    }

    const program = await postData({
      url,
      data,
    });
    return program;
  };
  const updateMediaInDB = async (data, id?: number | null): Promise<any> => {
    let url = "";

    url = `${import.meta.env.VITE_IP_API}/api/media/edit/${id}`;

    const media = await postData({
      url,
      data,
    });
    return media;
  };
  return { updateProgramInDB, updateProjectInDB, updateMediaInDB };
}
